import React, { useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'

import Alert from '../../../../1stlog-ui/src/components/Alert'
import Button from '../../../../1stlog-ui/src/components/Button'
import Card from '../../../../1stlog-ui/src/components/Card'
import PrintFormatSelect from '../../../../shipmetrics-shared/components/PrintFormatSelect'
import BlockedPopupAlert from '../../../components/BlockedPopupAlert'
import { TResult } from '../TReturnApp'

type TResultProps = {
  result: TResult
  onBack: () => void
}

const Result = (props: TResultProps): React.ReactElement => {
  const { result, onBack } = props

  const [wasPopupBlocked, setWasPopupBlocked] = useState(false)

  const onPopupBlocked = (): void => setWasPopupBlocked(true)

  const resetWasPopupBlocked = (): void => setWasPopupBlocked(false)

  return (
    <Container>
      <Row>
        <Col>
          <Alert
            success
            title={i18n.t('success', 'Erfolg')}
            button={
              <Button success onClick={onBack}>
                {i18n.t('return_another_order', 'Weitere Retoure erfassen')}
              </Button>
            }
          >
            {result.nolabel
              ? i18n.t(
                  'return_order_success_nolabel',
                  'Die Retoure wurde erfolgreich im System aktiviert.'
                )
              : i18n.t(
                  'return_order_success',
                  'Die Retoure wurde erfolgreich im System registriert.'
                )}
            {result.nolabel && (
              <p className="mt-1">
                {i18n.t(
                  'return_order_success_labelinfo',
                  'Bitte kleben Sie das Label, welches Sie für diesen Auftrag verwendet haben, gut sichtbar auf das Paket.'
                )}
              </p>
            )}
          </Alert>
        </Col>
      </Row>
      {wasPopupBlocked && (
        <Row>
          <Col>
            <BlockedPopupAlert onClose={resetWasPopupBlocked} />
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          {!result.nolabel && (
            <Card noHeader>
              <div className="py-2">
                <div>
                  <p>
                    {i18n.t(
                      'return_order_success_reopen_label_info',
                      'Sollte sich das Fenster mit dem Label nicht geöffnet haben, prüfen Sie bitte Ihren Popupblocker und öffnen Sie das Label durch klick auf den untenstehenden Button erneut.'
                    )}
                  </p>
                </div>
                <PrintFormatSelect
                  labelToken={result.label}
                  openOnMount
                  back={onBack}
                  url="/return/label/"
                  text={i18n.t('print_label_again', 'Label erneut drucken')}
                  onPopupBlocked={onPopupBlocked}
                />
              </div>
            </Card>
          )}
        </Col>
      </Row>
    </Container>
  )
}

export default Result
